import { render, staticRenderFns } from "./IconValidation.vue?vue&type=template&id=7b175f3e"
import script from "./IconValidation.vue?vue&type=script&lang=js"
export * from "./IconValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports